export default function GlobalLoader() {
  return (
    <div id='global-loader'>
      <img
        src='https://dk52za6l5gacn.cloudfront.net/theme/assets/images/icons/loader.svg'
        alt='loader'
      />
    </div>
  )
}
